exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#mapContainer[data-v-6006c94b] {\n  width: 100%;\n  height: 424px;\n}\n.google-map[data-v-6006c94b] {\n  width: 100%;\n  height: 110vh;\n  margin: 0 auto;\n  background: gray;\n}\n", ""]);

// exports
